import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ParkingPaid = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="parking-paid"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.93 16.648h-4.395c-.809 0-1.465.656-1.465 1.465v2.93c0 .809.656 1.465 1.465 1.465h4.395a2.934 2.934 0 002.93-2.93 2.934 2.934 0 00-2.93-2.93z"
        fill={fill}
      />
      <path
        d="M44.676 2H9.324C5.286 2 2 5.286 2 9.324v35.352C2 48.714 5.286 52 9.324 52h35.352C48.714 52 52 48.714 52 44.676V9.324C52 5.286 48.714 2 44.676 2zM29.93 28.367h-5.86v13.38c0 .808-.655 1.464-1.465 1.464h-2.93a1.465 1.465 0 01-1.464-1.465V12.254c0-.81.656-1.465 1.465-1.465h9.907c4.25 0 8.155 2.865 8.965 7.037 1.09 5.611-3.199 10.541-8.618 10.541z"
        fill={fill}
      />
      <circle cx="46.5" cy="46.5" r="11.5" fill={fill} stroke="#fff" strokeWidth="2" />
      <path
        d="M49.516 49.71c-.65.683-1.482 1.06-2.343 1.06-1.411 0-2.633-.992-3.208-2.424h3.92a.615.615 0 100-1.23h-4.232a5.148 5.148 0 01.01-1.309h4.222a.615.615 0 100-1.23h-3.887c.587-1.39 1.79-2.346 3.175-2.346.86 0 1.693.376 2.343 1.06a.615.615 0 00.892-.848c-.885-.93-2.033-1.443-3.235-1.443-2.051 0-3.805 1.49-4.486 3.577h-1.649a.615.615 0 000 1.23h1.386a6.343 6.343 0 00-.009 1.308h-1.377a.615.615 0 000 1.231h1.625c.662 2.127 2.433 3.654 4.51 3.654 1.202 0 2.35-.513 3.234-1.443a.615.615 0 00-.891-.848z"
        fill="#fff"
      />
    </svg>
  );
};
/* eslint-enable max-len */

ParkingPaid.defaultProps = {
  className: null,
};

ParkingPaid.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ParkingPaid;
